module.exports = __webpack_public_path__ + "static/media/van.3a3891a4.svg";